/** Free Results — Suggested Immediate Actions (fixed 3 management actions). */
import { Lightning } from '@phosphor-icons/react';

const NAVY = '#0B2951';
const TEAL = '#008C85';
const GRAY = '#6D7586';

const ACTIONS = [
  'Identify the workflow with the highest repetitive manual effort.',
  'Check whether the workflow is performed consistently by different staff.',
  'Select one workflow for deeper diagnostic review before automation.',
];

const ImmediateActions = () => (
  <section
    className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 shadow-sm mb-8"
    data-testid="immediate-actions-card"
  >
    <div className="flex items-center gap-3 mb-4">
      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center"
        style={{ background: `${TEAL}1A` }}
      >
        <Lightning size={20} weight="bold" style={{ color: TEAL }} />
      </div>
      <h3 className="text-lg sm:text-xl font-bold" style={{ color: NAVY }}>
        Suggested Immediate Actions
      </h3>
    </div>
    <p className="text-sm mb-5 leading-relaxed" style={{ color: GRAY }}>
      Three actions management can initiate internally before any external engagement.
    </p>
    <ol className="space-y-3">
      {ACTIONS.map((action, idx) => (
        <li
          key={action}
          className="flex gap-3"
          data-testid={`immediate-action-${idx}`}
        >
          <div
            className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
            style={{ background: NAVY, color: '#FFFFFF' }}
          >
            {idx + 1}
          </div>
          <p className="text-sm sm:text-base text-slate-700 leading-relaxed pt-0.5">{action}</p>
        </li>
      ))}
    </ol>
  </section>
);

export default ImmediateActions;
